/* eslint-disable*/
import { React, useState } from 'react';
import { Box, Divider, Typography, Menu, MenuItem } from '@material-ui/core';
import { styled } from '@material-ui/styles';
import Button from '@mui/material/Button';
import { useLocation, useNavigate, a } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { changePageflag } from 'feactures/date/dateSlice';
import banner_sidemenu from './images/banner_sidemenu.png';
import oxcim_new_logo from './images/oxcim_new_logo.png';
import bar_graph_icon from './icons/bar_graph.svg';
import circle_graph_icon from './icons/circle_graph.svg';
import banner_free from './images/banner_free.png';
import banner_year from './images/banner_year.png';
import banner_ope from './images/banner_ope.png';
import graph_icon from './icons/graph.svg';
import human_icon from './icons/human.svg';
import { userinfo } from 'feactures/user/userSlice';
import { sideMenuProps } from 'feactures/section/pageSlice';

import moment from 'moment';
const CustomButton = styled(Button)({
  textDecoration: 'none',
  color: '#fff',
  borderRadius: 0,
  height: '30px',
  width: '240px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'start',
  padding: '5px 25px 5px 60px',
  // '@media screen and (max-height:800px)': {
  //   height: '35px',
  //   padding: '5px 20px 5px 25px'
  // },
  // '@media screen and (max-height:700px)': {
  //   height: '28px',
  //   padding: '0px 20px 0px 25px',
  //   fontSize: '14px'
  // },
  borderLeft: '4px solid transparent',
  transition: 'all 0.3s ease',
  // textDecoration: 'underline',
  fontSize: '14px',
  '&:hover': {
    color: '#007bff',
    backgroundColor: '#f2f2f2'
    // textDecoration: 'underline',
    // borderLeft: '4px solid #007bff'
  }
});

const SelectedButton = styled(Button)({
  textDecoration: 'none',
  color: '#718CC6',
  backgroundColor: '#FFF8E5',
  borderRadius: 0,
  height: '30px',
  width: '240px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'start',
  padding: '5px 25px 5px 60px',
  // '@media screen and (max-height:800px)': {
  //   height: '35px',
  //   padding: '5px 20px 5px 25px'
  // },
  // '@media screen and (max-height:700px)': {
  //   height: '28px',
  //   padding: '0px 20px 0px 25px',
  //   fontSize: '14px'
  // },
  borderLeft: '4px solid transparent',
  transition: 'all 0.3s ease',
  // textDecoration: 'underline',
  fontSize: '14px',
  '&:hover': {
    color: '#007bff',
    backgroundColor: '#f2f2f2'
    // textDecoration: 'underline',
    // borderLeft: '4px solid #007bff'
  }
});

const SideMenu = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const menuId = 'side-menu';
  const user = useSelector(userinfo);
  const sideMenuOpen = useSelector(sideMenuProps);
  const handleClick = (e, path) => {
    e.preventDefault();
    navigate(`/app${path}`);
    // dispatchでpathの中身を渡す→DashboardNavbarで受け取って、マーケットのpathだったら更新ボタンを非表示にする
    dispatch(changePageflag(path));
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const page = location.pathname;
  const isMenuOpen = Boolean(anchorEl);
  const amazonStartDate = user.plan.amazon.start_date;
  const amazonEndDate = user.plan.amazon.end_date;
  const rakutenStartDate = user.plan.rakuten.start_date;
  const rakutenEndDate = user.plan.rakuten.end_date;
  const yahooStartDate = user.plan.yahoo.start_date;
  const yahooEndDate = user.plan.yahoo.end_date;

  let yearContract = false;
  if (amazonStartDate !== '' && amazonEndDate !== '') {
    const start = moment(amazonStartDate);
    const end = moment(amazonEndDate).add(1, 'days');
    const diff = end.diff(start, 'month');
    if (diff === 12) {
      yearContract = true;
    }
  }
  if (rakutenStartDate !== '' && rakutenEndDate !== '') {
    const start = moment(rakutenStartDate);
    const end = moment(rakutenEndDate).add(1, 'days');
    const diff = end.diff(start, 'month');
    if (diff === 12) {
      yearContract = true;
    }
  }
  if (yahooStartDate !== '' && yahooEndDate !== '') {
    const start = moment(yahooStartDate);
    const end = moment(yahooEndDate).add(1, 'days');
    const diff = end.diff(start, 'month');
    if (diff === 12) {
      yearContract = true;
    }
  }

  let banner_url;
  if (
    user.plan.amazon.plan === 'ご利用無し' &&
    user.plan.rakuten.plan === 'ご利用無し' &&
    user.plan.yahoo.plan === 'ご利用無し'
  ) {
    banner_url = banner_free;
  } else if (yearContract) {
    banner_url = banner_ope;
  } else {
    banner_url = banner_year;
  }

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePlan = () => {
    handleMenuClose();
    navigate('/app/sys/plan');
  };
  const handleBilling = () => {
    handleMenuClose();
    navigate('/app/sys/billing');
  };

  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handlePlan}>プラン管理</MenuItem>
      <MenuItem onClick={handleBilling}>ご請求情報</MenuItem>
    </Menu>
  );

  return (
    <>
      <Box
        position="fixed"
        zIndex={20}
        height="100vh"
        width="240px"
        bgcolor="#718CC6"
        sx={{
          transition: 'left 0.3s',
          left: sideMenuOpen ? 0 : '-100%'
        }}
      >
        <Box
          overflow="auto"
          position="fixed"
          height="100%"
          width="240px"
          color="#fff"
          sx={{
            boxShadow: '0 0 20px rgba(0, 0, 0, 0.05)',
            transition: 'left 0.3s',
            left: sideMenuOpen ? 0 : '-100%'
            // '@media screen and (max-height:800px)': {
            //   padding: '5px 20px 10px 20px'
            // },
            // '@media screen and (max-height:600px)': {
            //   padding: '5px 20px 10px 10px'
            // }
          }}
        >
          {/* <DesktopWindowsOutlinedIcon sx={{ mr: 1 }} /> */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column'
            }}
          >
            <img src={oxcim_new_logo} alt="logo" style={{ width: '60%' }} />
            <Box
              sx={{
                border: '1px solid #fff',
                borderRadius: '50px',
                width: '55px',
                height: '55px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <img
                src={human_icon}
                alt="human-icon"
                style={{ width: '40px', height: '40px' }}
              />
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <Typography fontSize={'16px'}>
                {user.accountName}&nbsp;様
              </Typography>
              <Button
                onClick={handleProfileMenuOpen}
                sx={{ color: '#fff', minWidth: '0px' }}
              >
                ▼
              </Button>
            </Box>
          </Box>
          <Divider
            sx={{ my: 2, border: '1px solid #fff', width: '80%', mx: 'auto' }}
          />
          <Box sx={{ mb: '20px' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', ml: '20px' }}>
              <img
                src={graph_icon}
                alt="グラフアイコン"
                style={{ width: '20px' }}
              />
              <Typography
                fontSize="17px"
                fontWeight="300"
                color="#fff"
                pl="10px"
                letterSpacing="1px"
                // sx={{
                //   marginBottom: '10px',
                //   '@media screen and (max-height:800px)': {
                //     marginBottom: '5px'
                //   },
                //   '@media screen and (max-height:700px)': {
                //     marginBottom: '0px',
                //     fontSize: '15px'
                //   }
                // }}
              >
                オーバービュー
              </Typography>
            </Box>
            <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
              <li
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start'
                }}
              >
                {page === '/app/overview' ? (
                  <SelectedButton
                    value="/overview"
                    onClick={(e) => handleClick(e, '/overview')}
                  >
                    -&nbsp;全体実績
                  </SelectedButton>
                ) : (
                  <CustomButton
                    value="/overview"
                    onClick={(e) => handleClick(e, '/overview')}
                  >
                    -&nbsp;全体実績
                  </CustomButton>
                )}
              </li>
            </ul>
          </Box>
          <Box sx={{ mb: '20px' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', ml: '20px' }}>
              <img
                src={bar_graph_icon}
                alt="棒グラフアイコン"
                style={{ width: '20px' }}
              />
              <Typography
                fontSize="17px"
                fontWeight="300"
                pl="10px"
                letterSpacing="1px"
                // sx={{
                //   marginTop: '17px',
                //   marginBottom: '10px',
                //   '@media screen and (max-height:800px)': {
                //     marginBottom: '5px'
                //   },
                //   '@media screen and (max-height:700px)': {
                //     marginBottom: '0px',
                //     fontSize: '15px'
                //   }
                // }}
              >
                KPIビュー
              </Typography>
            </Box>

            <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
              <li
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start'
                }}
              >
                {page === '/app/monitoring' ? (
                  <SelectedButton
                    value="/monitoring"
                    onClick={(e) => handleClick(e, '/monitoring')}
                  >
                    -&nbsp;KPIサマリ
                  </SelectedButton>
                ) : (
                  <CustomButton
                    value="/monitoring"
                    onClick={(e) => handleClick(e, '/monitoring')}
                  >
                    -&nbsp;KPIサマリ
                  </CustomButton>
                )}
              </li>
              {/* <li
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start'
            }}
          >
            <i style={{ marginRight: '10px' }}></i>
            {page === '/app/sales' ? (
              <SelectedButton
                value="/sales"
                onClick={(e) => handleClick(e, '/sales')}
              >
                商品別売上
              </SelectedButton>
            ) : (
              <CustomButton
                value="/sales"
                onClick={(e) => handleClick(e, '/sales')}
              >
                商品別売上
              </CustomButton>
            )}
          </li>
          <li
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start'
            }}
          >
            <i style={{ marginRight: '10px' }}></i>
            <CustomButton
              value="/numberviews"
              onClick={(e) => handleClick(e, '/numberviews')}
            >
              閲覧数
            </CustomButton>
          </li>
          <li
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start'
            }}
          >
            <i style={{ marginRight: '10px' }}></i>
            <CustomButton value="/cvr" onClick={(e) => handleClick(e, '/cvr')}>
              CVR
            </CustomButton>
          </li>
          <li
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start'
            }}
          >
            <i style={{ marginRight: '10px' }}></i>
            {page === '/app/unitprice' ? (
              <SelectedButton
                value="/unitprice"
                onClick={(e) => handleClick(e, '/unitprice')}
              >
                販売価格
              </SelectedButton>
            ) : (
              <CustomButton
                value="/unitprice"
                onClick={(e) => handleClick(e, '/unitprice')}
              >
                販売価格
              </CustomButton>
            )}
          </li> */}
            </ul>
          </Box>
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', ml: '20px' }}>
              <img
                src={circle_graph_icon}
                alt="円グラフアイコン"
                style={{ width: '20px' }}
              />
              <Typography
                fontSize="17px"
                fontWeight="300"
                // sx={{
                //   // marginTop: '17px',
                //   marginBottom: '10px',
                //   '@media screen and (max-height:800px)': {
                //     // marginTop: '13px',
                //     marginBottom: '5px'
                //   },
                //   '@media screen and (max-height:700px)': {
                //     // marginTop: '5px',
                //     marginBottom: '0px',
                //     fontSize: '15px'
                //   }
                // }}
                pl="10px"
                letterSpacing="1px"
              >
                マーケットビュー
              </Typography>
            </Box>
            <Typography
              fontSize="14px"
              fontWeight="300"
              pl="45px"
              // sx={{
              //   cursor: 'default',
              //   marginTop: '20px',
              //   marginBottom: '10px',
              //   '@media screen and (max-height:800px)': {
              //     marginTop: '10px',
              //     marginBottom: '8px'
              //   },
              //   '@media screen and (max-height:700px)': {
              //     marginTop: '2px',
              //     marginBottom: '2px',
              //     fontSize: '14px'
              //   }
              // }}
            >
              ■市場
            </Typography>
            <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
              <li
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start'
                }}
              >
                {page === '/app/newcategoryboard' ? (
                  <SelectedButton
                    value="/newcategoryboard"
                    onClick={(e) => handleClick(e, '/newcategoryboard')}
                  >
                    -&nbsp;カテゴリ分析
                  </SelectedButton>
                ) : (
                  <CustomButton
                    value="/newcategoryboard"
                    onClick={(e) => handleClick(e, '/newcategoryboard')}
                  >
                    -&nbsp;カテゴリ分析
                  </CustomButton>
                )}
              </li>

              {/* <li
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start'
            }}
          >
            <i style={{ marginRight: '10px' }}></i>
            {page === '/app/categoryboard' ? (
              <SelectedButton
                value="/categoryboard"
                onClick={(e) => handleClick(e, '/categoryboard')}
              >
                カテゴリ(TOP100)
              </SelectedButton>
            ) : (
              <CustomButton
                value="/categoryboard"
                onClick={(e) => handleClick(e, '/categoryboard')}
              >
                カテゴリ(TOP100)
              </CustomButton>
            )}
          </li>
          <li
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start'
            }}
          >
            <i style={{ marginRight: '10px' }}></i>
            {page === '/app/ownproductboard' ? (
              <SelectedButton
                value="/ownproductboard"
                onClick={(e) => handleClick(e, '/ownproductboard')}
              >
                間接流通
              </SelectedButton>
            ) : (
              <CustomButton
                value="/ownproductboard"
                onClick={(e) => handleClick(e, '/ownproductboard')}
              >
                間接流通
              </CustomButton>
            )}
          </li> */}
            </ul>
            <Typography
              fontSize="14px"
              fontWeight="300"
              pl="45px"
              // sx={{
              //   cursor: 'default',
              //   marginTop: '20px',
              //   marginBottom: '10px',
              //   '@media screen and (max-height:800px)': {
              //     marginTop: '10px',
              //     marginBottom: '8px'
              //   },
              //   '@media screen and (max-height:700px)': {
              //     marginTop: '2px',
              //     marginBottom: '2px',
              //     fontSize: '14px'
              //   }
              // }}
            >
              ■競合
            </Typography>
            <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
              <li
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start'
                }}
              >
                {page === '/app/brandanalysis' ? (
                  <SelectedButton
                    value="/brandanalysis"
                    onClick={(e) => handleClick(e, '/brandanalysis')}
                  >
                    -&nbsp;店舗/ブランド分析
                  </SelectedButton>
                ) : (
                  <CustomButton
                    value="/brandanalysis"
                    onClick={(e) => handleClick(e, '/brandanalysis')}
                  >
                    -&nbsp;店舗/ブランド分析
                  </CustomButton>
                )}
              </li>
              <li
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start'
                }}
              >
                {page === '/app/brandcomparison' ? (
                  <SelectedButton
                    value="/brandcomparison"
                    onClick={(e) => handleClick(e, '/brandcomparison')}
                  >
                    -&nbsp;店舗/ブランド比較
                  </SelectedButton>
                ) : (
                  <CustomButton
                    value="/brandcomparison"
                    onClick={(e) => handleClick(e, '/brandcomparison')}
                  >
                    -&nbsp;店舗/ブランド比較
                  </CustomButton>
                )}
              </li>
              {/* <li
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start'
            }}
          >
            <i style={{ marginRight: '10px' }}></i>
            {page === '/app/measureanalysis' ? (
              <SelectedButton
                value="/measureanalysis"
                onClick={(e) => handleClick(e, '/measureanalysis')}
              >
                店舗/ブランド施策
              </SelectedButton>
            ) : (
              <CustomButton
                value="/measureanalysis"
                onClick={(e) => handleClick(e, '/measureanalysis')}
              >
                店舗/ブランド施策
              </CustomButton>
            )}
          </li> */}
              {/* <li
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start'
            }}
          >
            <i style={{ marginRight: '10px' }}></i>
            {page === '/app/productmeasures' ? (
              <SelectedButton
                value="/productmeasures"
                onClick={(e) => handleClick(e, '/productmeasures')}
              >
                商品施策
              </SelectedButton>
            ) : (
              <CustomButton
                value="/productmeasures"
                onClick={(e) => handleClick(e, '/productmeasures')}
              >
                商品施策
              </CustomButton>
            )}
          </li> */}
              <li
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start'
                }}
              >
                {page === '/app/otherproductboard' ? (
                  <SelectedButton
                    value="/otherproductboard"
                    onClick={(e) => handleClick(e, '/otherproductboard')}
                  >
                    -&nbsp;商品分析
                  </SelectedButton>
                ) : (
                  <CustomButton
                    value="/otherproductboard"
                    onClick={(e) => handleClick(e, '/otherproductboard')}
                  >
                    -&nbsp;商品分析
                  </CustomButton>
                )}
              </li>
              {/* <li
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start'
            }}
          >
            <i style={{ marginRight: '10px' }}></i>
            {page === '/app/oldotherproductboard' ? (
              <SelectedButton
                value="/oldotherproductboard"
                onClick={(e) => handleClick(e, '/oldotherproductboard')}
              >
                競合商品
              </SelectedButton>
            ) : (
              <CustomButton
                value="/otherproductboard"
                onClick={(e) => handleClick(e, '/oldotherproductboard')}
              >
                競合商品
              </CustomButton>
            )}
          </li> */}
              {/* <li
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start'
            }}
          >
            <i style={{ marginRight: '10px' }}></i>
            {page === '/app/category1/sales' ? (
              <SelectedButton
                value="/category1/sales"
                onClick={(e) => handleClick(e, '/category1/sales')}
              >
                カテゴリNo.1商品
              </SelectedButton>
            ) : (
              <CustomButton
                value="/category1/sales"
                onClick={(e) => handleClick(e, '/category1/sales')}
              >
                カテゴリNo.1商品
              </CustomButton>
            )}
          </li> */}
            </ul>
          </Box>
          <Box sx={{ my: '20px' }}>
            <a
              href="https://www.oxcim.net/plan-change"
              target="_blank"
              style={{
                width: 'fit-content',
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <img
                src={banner_url}
                alt="サイドメニューのバナー"
                style={{ width: '90%' }}
              />
            </a>
          </Box>
        </Box>
      </Box>
      {renderMenu}
    </>
  );
};

export default SideMenu;
